/**
 * Ponto de entrada do front.
 *
 * O quê: encontra o elemento raiz no HTML, monta a árvore React dentro dele e
 * liga o roteador.
 *
 * Como: a busca pelo elemento raiz é verificada em vez de forçada com `!`. Se
 * `index.html` for alterado e a div sumir, o erro apontará exatamente a causa,
 * em vez de estourar um "null is not an object" no meio do React. StrictMode
 * fica ativo porque monta cada componente duas vezes em desenvolvimento, o que
 * expõe efeito colateral mal isolado antes de virar bug em produção.
 *
 * Utiliza: react-dom/client, react-router (RouterProvider), os provedores
 * globais e a folha de tokens index.css.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Providers } from './app/providers';
import { router } from './app/router';
import './index.css';

const elementoRaiz = document.getElementById('root');

if (!elementoRaiz) {
  throw new Error('Elemento #root não encontrado em index.html — o app não pode ser montado.');
}

createRoot(elementoRaiz).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
